export default {
  subscribeButton: {
    subscribe_click: 'yes',
  },
  paywallSubscribeButton: {
    subscribe_click: 'yes',
  },
  subscribe: {
    subscribe_click: 'yes',
  },
};
